import {DataStatus, openDialog} from 'platform/components';
import {VStack} from 'platform/foundation';
import {match} from 'ts-pattern';

import {isEmpty} from 'ramda';

import {
  OAuthEmailCredentialsResponseBody,
  SmtpCredentialsResponseBody,
  useListEmailCredentialsQuery,
  useListEmailProviderQuery,
} from '@dms/api/core';
import {
  CreateEmailServiceProvider,
  SmtpCredentialsCard,
  isOAuthCredential,
  OAuthCredentialsCard,
  OAuthCredentialsDialogProvider,
} from '@dms/features/email-smtp';
import i18n from '@dms/i18n';
import {SettingsSection, SettingsTemplate} from '@dms/settings/shared';

export function EmailServices() {
  const {isLoading: loadingEmailProviders, isError: errorEmailProviders} =
    useListEmailProviderQuery();

  const {
    data: emailCredentials,
    isLoading: loadingEmailCredentials,
    isError: errorEmailCredentials,
  } = useListEmailCredentialsQuery({ownerType: 'tenant'});

  const handleCreate = () =>
    openDialog(<CreateEmailServiceProvider ownerType="tenant" />, {
      title: i18n.t('page.integrations.labels.setupNewEmailService'),
    });

  const isLoading = loadingEmailCredentials || loadingEmailProviders;
  const isError = errorEmailCredentials || errorEmailProviders;

  return (
    <SettingsTemplate
      isLoading={isLoading}
      isError={isError}
      header={{
        title: i18n.t('page.integrations.labels.emailServices'),
        actions: [
          {
            type: 'button',
            title: i18n.t('general.labels.createNew'),
            onClick: handleCreate,
          },
        ],
      }}
      data-testid="integrations-emailServices-settings"
    >
      <SettingsSection>
        <OAuthCredentialsDialogProvider credentials={emailCredentials} ownerType="tenant">
          <DataStatus
            spacing={10}
            isEmpty={isEmpty(emailCredentials?.credentials)}
            action={{
              title: i18n.t('general.labels.createNew'),
              onClick: handleCreate,
              leftIcon: 'content/add_circle',
            }}
          >
            <VStack spacing={4}>
              {emailCredentials?.credentials.map((credentials) =>
                match(isOAuthCredential(credentials))
                  .with(true, () => (
                    <OAuthCredentialsCard
                      key={credentials.id}
                      credentials={credentials as OAuthEmailCredentialsResponseBody}
                      ownerType="tenant"
                    />
                  ))
                  .otherwise(() => (
                    <SmtpCredentialsCard
                      key={credentials.id}
                      credentials={credentials as SmtpCredentialsResponseBody}
                      ownerType="tenant"
                    />
                  ))
              )}
            </VStack>
          </DataStatus>
        </OAuthCredentialsDialogProvider>
      </SettingsSection>
    </SettingsTemplate>
  );
}
